/**
 * @fileoverview
 * See `types.ts` for context on these symbols.
 */

import { Symbol_for } from "@/shared/snapshot";

export const SCRAMJETCLIENTNAME = "scramjet client global";
export const SCRAMJETCLIENT = Symbol_for(SCRAMJETCLIENTNAME);
